import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { capitalize } from 'lodash';
import Toggle from 'react-bootstrap-toggle';

import {
  getUser,
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';

import {
  fetchEmailAlerts,
} from '../../../Setup/SetupActions';

import {
  updateEmailAlertSubscription,
} from '../../../Auth/AuthActions';

/** Allow user to see the Email Alerts they are subscribed to and a toggle allowing them to unsubscribe */
class EmailAlertSubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      emailAlerts: [],
    };
    this.handleSubscribeToggle = this.handleSubscribeToggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ loading: true, emailAlerts: [] }, () => {
        const { organization, dispatch } = this.props;
        const { _id } = organization;
        dispatch(fetchEmailAlerts(_id))
          .then(
            (emailAlerts) => {
              this.setState({
                loading: false,
                emailAlerts,
              });
            },
            (_error) => {
              this.setState({
                loading: false,
                error: 'Email alert fetch failed',
              });
            },
          );
      });
    }
  }

  handleSubscribeToggle(type, subscribed) {
    const { dispatch, user } = this.props;

    dispatch(updateEmailAlertSubscription(user._id, {
      type,
      subscribed,
    }))
      .then(
        (_updatedUser) => {
          // do nothing.
        },
        (_error) => {
          this.setState({
            error: 'Email alert subscription update failed',
          });
        },
      );
  }

  renderEmailAlert(emailAlert) {
    const { user } = this.props;

    let frequency = null;
    if (emailAlert.frequency === 'weekly') {
      frequency = 'Weekly';
    } else if (emailAlert.frequency === 'biweekly') {
      frequency = 'Bi-Weekly';
    } else if (emailAlert.frequency === 'monthly') {
      frequency = 'Monthly';
    }

    let emailAlertSubscribed;
    let type = null;
    if (emailAlert.type === 'buyerFeedback') {
      type = 'Buyer Feedback Digest';
      emailAlertSubscribed = !(user.email_alert_unsubscribe || {}).buyer_feedback;
    } else if (emailAlert.type === 'missingFeedback') {
      type = 'Missing Feedback Digest for Managers';
      emailAlertSubscribed = !(user.email_alert_unsubscribe || {}).missing_feedback;
    }

    let helpText = null;
    if (emailAlert.allow_unsubscribe === false) {
      helpText = `Your organization has made this a mandatory ${frequency.toLowerCase()} communication`;
    } else if (emailAlertSubscribed) {
      helpText = `You will receive an email digest of this alert ${frequency.toLowerCase()}`;
    } else {
      helpText = `You will not receive an email digest of this alert`;
    }

    return (
      <div className="panel panel-default" key={emailAlert._id}>
        <div className="panel-heading">
          {capitalize(frequency)} {type}
        </div>
        <div className="panel-body">
          <FormGroup style={{ marginBottom: 0 }}>
            <ControlLabel>Subscribe</ControlLabel>
            {' '}
            <Toggle
              onClick={() => this.handleSubscribeToggle(emailAlert.type, !emailAlertSubscribed)}
              on={<span>On</span>}
              off={<span>Off</span>}
              size="xs"
              onstyle="success"
              offstyle="danger"
              active={emailAlert.allow_unsubscribe === false || emailAlertSubscribed}
              disabled={emailAlert.allow_unsubscribe === false}
            />
            <HelpBlock>{helpText}</HelpBlock>
          </FormGroup>
        </div>
      </div>
    );
  }

  render() {
    const { open, onClose } = this.props;
    const { loading, emailAlerts, error } = this.state;

    return (
      <Modal show={open} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title><Fa name="envelope" /> Email Alert Subscriptions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && 'Loading...'}
          {error && error}
          {!loading && !error && emailAlerts.map((emailAlert) => this.renderEmailAlert(emailAlert))}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={onClose}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    organization: getUserCurrentOrganization(state),
  };
}

EmailAlertSubscriptionModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    user_id: PropTypes.string.isRequired,
    email_alert_unsubscribe: PropTypes.shape({
      buyer_feedback: PropTypes.bool,
      missing_feedback: PropTypes.bool,
    }),
  }).isRequired,
};
EmailAlertSubscriptionModal.defaultProps = {
  open: false,
};

export default connect(mapStateToProps)(EmailAlertSubscriptionModal);
